import React from 'react';
import { Global, css } from '@emotion/react';

const MarkdownGlobalStyle: React.FC = () => (
  <Global
    styles={css`
      #x-ai-chatbot {
        .ai-markdown-body {
          box-sizing: border-box;
          min-width: 200px;
          margin: 0 auto;
          background: none !important;
        }
        .ai-markdown-body p {
          margin: 0;
        }

        .ai-markdown-body h1,
        .ai-markdown-body h2,
        .ai-markdown-body h3,
        .ai-markdown-body h4,
        .ai-markdown-body h5,
        .ai-markdown-body h6 {
          font-weight: bold;
          margin: 0.1em 0;
          line-height: 1.4;
        }
        .ai-markdown-body h1 { font-size: 2em; }
        .ai-markdown-body h2 { font-size: 1.5em; }
        .ai-markdown-body h3 { font-size: 1.2em; }
        .ai-markdown-body h4 { font-size: 1em; }
        .ai-markdown-body h5 { font-size: 0.9em; }
        .ai-markdown-body h6 { font-size: 0.8em; }

        .ai-markdown-body ul,
        .ai-markdown-body ol {
          margin: 0 0 1em 1.5em;
          padding: 0;
        }
        .ai-markdown-body li {
          margin: 0.2em 0;
        }

        .ai-markdown-body blockquote {
          margin: 1em 0;
          padding: 0.5em 1em;
          color: #666;
          border-left: 4px solid #e0e0e0;
          background: #fafafa;
        }

        .ai-markdown-body code {
          background: #f5f5f5;
          border-radius: 3px;
          padding: 2px 4px;
          font-size: 95%;
          font-family: 'Fira Mono', 'Menlo', 'Consolas', monospace;
        }

        .ai-markdown-body pre {
          background: #f5f5f5;
          border-radius: 4px;
          padding: 12px;
          overflow-x: auto;
          font-size: 14px;
          margin: 16px 0;
        }

        .ai-markdown-body a {
          color: #1677ff;
          text-decoration: underline;
          word-break: break-all;
        }

        /* 表格容器 */
        .ai-markdown-body table {
          display: block;
          overflow-x: auto;
          border-collapse: collapse;
          width: max-content;
          min-width: 100%;
          margin: 16px 0;
          font-size: 14px;
          /* 防止表格被父容器裁剪 */
          max-width: 100%;
        }
        .ai-markdown-body th,
        .ai-markdown-body td {
          border: 1px solid #e0e0e0;
          padding: 8px 12px;
          text-align: left;
          min-width: 120px; /* 设置最小宽度，可根据实际调整 */
          white-space: nowrap; /* 防止内容换行 */
        }
        .ai-markdown-body th {
          background: #f5f5f5;
          font-weight: bold;
        }

        .message-chatgpt p,
        .message-chatgpt pre[class*='language-'] {
          white-space: pre-wrap;
        }
        .message-chatgpt p:first-child {
          margin-top: 0;
        }
        .message-chatgpt pre[class*='language-'],
        .message-chatgpt code[class*='language-'] {
          text-shadow: none;
        }
        .message-chatgpt pre[class*='language-'] {
          font-size: 14px;
          border-radius: 0.25rem;
          position: relative;
        }

        
        .message-chatgpt a:-webkit-any-link {
          cursor: pointer;
          text-decoration: underline;
        }
        .message-chatgpt .prism-title {
          position: sticky;
          left: 0;
          right: 0;
          width: 100%;
          padding: 0.75rem;
          margin-bottom: 15px;
          border-radius: 4px;
          background-color: #343540;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .message-chatgpt .prism-title.dark {
          background-color: #1f2937;
          color: #6b7280;
        }
        .message-chatgpt .prism-copy {
          float: right;
          cursor: pointer;
          color: inherit;
        }
        .message-chatgpt .prism-copy:hover {
          color: #9df69b;
        }
        .message-chatgpt .prism-copy.dark:hover {
          color: #d1d5db;
        }
        .copy-disable {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
      }
    `}
  />
);

export default MarkdownGlobalStyle;
